import { render, staticRenderFns } from "./CheckoutHeader.vue?vue&type=template&id=451f5c59&scoped=true"
import script from "./CheckoutHeader.vue?vue&type=script&lang=js"
export * from "./CheckoutHeader.vue?vue&type=script&lang=js"
import style0 from "./CheckoutHeader.vue?vue&type=style&index=0&id=451f5c59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451f5c59",
  null
  
)

export default component.exports